<template>
    <div class="TopCenterContent">
        <div :style="{ height: listData.length === 1 ? '100%' : '', width: listData.length === 1 ? '100%' : '' }"
            v-for="(v, i) in listData" :key="i">
            <div class="value">{{ numberToCurrencyNo(v.value) }}</div>
            <div class="right">
                <div class="name">{{ v.name }}</div>
                <div class="unit">{{ v.unit }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { numberToCurrencyNo } from "@/assets/js/utils";
export default {
    name: "TopCenterContent",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
    },
    components: {},
    data() {
        return {}
    },
    computed: {},
    methods: {
        numberToCurrencyNo
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.TopCenterContent {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
    flex-wrap: wrap;

    &>div {
        width: 45%;
        background: url("~@/assets/images/msgt/GFJSBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 12px;
        @include setFlexAround;
        .value {
            height: 30px;
            font-size: 26px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 30px;
        }

        .right {
            .name {
                height: 14px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #16E9F4;
                line-height: 14px;
            }

            .unit {
                height: 12px;
                font-size: 12px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #868B99;
                line-height: 12px;
                margin-top: 8px;
            }
        }
    }
}</style>